














































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Equipment from "../../../store/entities/equipment";
@Component
export default class EditEquipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  selfloorlist = [];
  selwarehouselist = [];
  updateThreshold = false;
  updateTempHumi = false;
  updateEqutime = false;
  updateTimer1 = false;
  updateTimer2 = false;
  updateIanport = false;
  updateWorkMode = false;
  upgrade = false;
  created() {}
  equipment: Equipment = new Equipment();
  save() {
    (this.$refs.equipmentForm as any).validate(async (valid: boolean) => {
      if (valid) {
        var dates = new Date();
        if(this.updateThreshold == true){
          this.equipment.updateThreshold = 1;
          this.updateThreshold = false;
        }else{
          this.equipment.updateThreshold = 0;
        }
        if(this.updateTempHumi == true){
          this.equipment.updateTempHumi = 1;
          this.updateTempHumi = false;
        }
        else{
          this.equipment.updateTempHumi = 0;
        }
        if(this.updateEqutime == true){
          this.equipment.updateEqutime = 1;
          this.updateEqutime = false;
        }
        else{
          this.equipment.updateEqutime = 0;
        }
        if(this.updateTimer1 == true){
          this.equipment.updateTimer1 = 1;
          this.updateTimer1 = false;
        }
        else{
          this.equipment.updateTimer1 = 0;
        }
        if(this.updateTimer2 == true){
          this.equipment.updateTimer2 = 1;
          this.updateTimer2 = false;
        }
        else{
          this.equipment.updateTimer2 = 0;
        }
        if(this.updateIanport == true){
          this.equipment.updateIanport = 1;
          this.updateIanport = false;
        }
        else{
          this.equipment.updateIanport = 0;
        }
        if(this.updateWorkMode == true){
          this.equipment.updateWorkMode = 1;
          this.updateWorkMode = false;
        }
        else{
          this.equipment.updateWorkMode = 0;
        }
        if(this.upgrade == true){
          this.equipment.upgrade = 1;
          this.upgrade = false;
        }
        else{
          this.equipment.upgrade = 0;
        }
        if(this.equipment["equtime"] == ""){
          this.equipment["equtime"] = dates.toLocaleDateString();
        }
        await this.$store.dispatch({
          type: "equipment/update",
          data: this.equipment,
        });
        (this.$refs.equipmentForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }else{
      }
    });
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
   get floor() {
    return this.$store.state.floor.list;
  }
  get threshold(){
    //console.log(this.$store.state.threshold.list);
    return this.$store.state.threshold.list;
  }
   selfactory(value:number){
    this.equipment.ftId = value;
    if(value !=0 && value != undefined){
      this.getselwarehouse();
    }
  }
  selwarehouse(value:number){
    this.equipment.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    // this.getfloor();
  }
  selfloor(value:number){
    this.equipment.fId = value;
  }
  async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.equipment,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.equipment,
    });
  }
  cancel() {
    (this.$refs.equipmentForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.updateThreshold = false;
      this.updateTempHumi = false;
      this.updateEqutime = false;
      this.updateTimer1 = false;
      this.updateTimer2 = false;
      this.updateIanport = false;
      this.updateWorkMode = false;
      this.upgrade = false;
    } else {
      this.equipment = Util.extend(true, {}, this.$store.state.equipment.editEquipment);
      this.selfactory(this.equipment.ftId);
      this.selwarehouse(this.equipment.wId);
      this.selfloor(this.equipment.fId);
       if(this.equipment.updateThreshold == 1){
          this.updateThreshold = true;
        }
        if(this.equipment.updateTempHumi == 1){
          this.updateTempHumi = true;
        }
        if(this.equipment.updateEqutime == 1){
          this.updateEqutime = true;
        }
        if(this.equipment.updateTimer1 == 1){
          this.updateTimer1 = true;
        }
        if(this.equipment.updateTimer2 == 1){
          this.updateTimer2 = true;
        }
        if(this.equipment.updateIanport == 1){
          this.updateIanport = true;
        }
        if(this.equipment.updateWorkMode == 1){
          this.updateWorkMode = true;
        }
        if(this.equipment.upgrade == 1){
          this.upgrade = true;
        }
      //console.log(this.equipment);
    }
  }
   equipmentRule = {
     ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    mac: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    numbler: [{transform: (value) => String(value), required: true, message: "请填写位置编号", trigger: "blur" }],
    //tId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
  };
}
